import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteCertificate = (certificateId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.ADMIN.CERTIFICATE_MANAGEMENT.DELETE_CERTIFICATE(certificateId)
  );
};

export default deleteCertificate;
